// Copyright (c) 2019 Deere & Company

/* eslint-disable complexity, max-params */

export const buildPayload = (selectedAccounts, selectedSpaLevels, exportToExcel = '', language = '', listId = '', layoutName = '') => ({
    accounts: selectedAccounts,
    export: exportToExcel,
    language,
    layout: layoutName,
    listId,
    statuses: selectedSpaLevels.map(selectedSpaLevel => selectedSpaLevel.key)
});

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/tabm/wip/services/spa-claims-build-payload.js